// import { app, scriptService } from "../../feathers";
import { actions } from "../../actionsProcessor";
// import { EventBus } from "../../eventBus";
// import router from "../../routes.js";
// import runHook from "Js/hookHandler";

export default {
  state: {
    actions: [],
    threads: [],
    isRunning: false,
    isPaused: false
  },

  actions: {
    ACTIONS_QUEUE: ({ commit, state, dispatch, rootState }, actionsArrOrObj ) => {
      // var actionsArrOrObjCopy = actionsArrOrObj ? _.cloneDeep(actionsArrOrObj) : actionsArrOrObj;
      if ( _.isEmpty(actionsArrOrObj) || ( actionsArrOrObj.actions  && _.isEmpty(actionsArrOrObj.actions)) )  {
        //Neded to continue thread in case of empty named actions
        actionsArrOrObj && actionsArrOrObj.actions  && _.isEmpty(actionsArrOrObj.actions) ? dispatch("ACTIONS_DO", {idThread: actionsArrOrObj.idThread}) : null
        return;
      }
      var actionsArray = [];
      var idThread = (actionsArrOrObj && actionsArrOrObj.idThread) || Date.now();
      var isInsert = !! actionsArrOrObj && actionsArrOrObj.insert // if obj
      var idForm = (!Array.isArray(actionsArrOrObj) && actionsArrOrObj.idForm) ? actionsArrOrObj.idForm : '';
      !idForm ? idForm = rootState.wndw.windows[0] && rootState.wndw.windows[0].formSchema.id : null;
      
      actionsArray = Array.isArray(actionsArrOrObj) ? actionsArrOrObj : actionsArrOrObj.actions

      if (!actionsArray || !actionsArray.length) {
        //Neded to continue thread in case of empty named actions
        dispatch("ACTIONS_DO", {idThread: (actionsArrOrObj && actionsArrOrObj.idThread) || null})
        return;
      }
      
      actionsArray.forEach(action => {
        if (!action.idThread) action.idThread = idThread;
        if (!action.idForm) action.idForm = idForm;
        
        state.threads.indexOf(action.idThread) === -1 ? state.threads.push(action.idThread) : null
      })
      actionsArray[0].preventClone
        ? null
        : (actionsArray = _.cloneDeep(actionsArray));
      isInsert ? commit("QUEUE_ACTIONS_INSERT", actionsArray) : commit("QUEUE_ACTIONS", actionsArray);
      // state.isRunning ? null : actions.process();
      dispatch("ACTIONS_DO", {idThread: actionsArray[0].idThread})

      return;
    },

    ACTIONS_DO: ({ commit, state, dispatch, rootState }, {idThread}) => {
      // runs the actioal actions but checks if they are running already etc
      if(state.isPaused) {
        setTimeout( 
        function(){ 
          dispatch('ACTIONS_DO', {idThread}); //idThread
        }
        , 50)
        return
      }

      if(state.isRunning) return ;
      // TODO if paused, try again in a little bit
      dispatch("ACTIONS_GET", {idThread}).then(action => {
        if (!action) {
          // No actions in the queue
          state.isRunning = false
          //Needs to be done with commit
          commit('POP_THREAD', idThread)
          return;
        }
        
        actions.dispatchAction(action);
        if (action.nonBlocking) dispatch("ACTIONS_DO", {idThread})
      });
      return;
    },

    ACTIONS_GET: ({ commit, state }, {idThread}) => {
      // state.isRunning = true; // must be running if we are fetching one
      var action = null;
      if (state.actions.length) {
        if (!idThread) {
          action = state.actions[0];
          commit("POP_ACTION");
          return action;
        }
        var index = state.actions.findIndex(e => e.idThread === idThread)
        action = index !== -1 ? state.actions[index] : null
        commit("POP_ACTION", index); //, index
      }
      else {
        // //Empty threads if actions queue is empty
        commit('CLEAR_THREADS')
      }
      // state.isRunning = !!state.actions.length;
      return action;
    },

    ACTIONS_CLEAR: ({ commit, state }, action) => {
      //If action is passed, it will clear only actions for the same thread as current action
      if (action && action.idThread) {
          let idThread = action.idThread
          let actionIndex = state.actions.findIndex(e => e.idThread === idThread);
          while (actionIndex !== -1) {
            commit("POP_ACTION", actionIndex);
            actionIndex = state.actions.findIndex(e => e.idThread === idThread);
          }
          commit('POP_THREAD', idThread)
          return;
        }
      
      state.actions = [];
      state.isRunning = false;
      return;
    },
    
    ACTIONS_PAUSE: ({ commit, state }, isPaused) => {
      // commit('PAUSE_ACTIONS', isPaused)
      state.isPaused = isPaused // not seeming to update fast enough
      return;
    }
  },

  mutations: {
    QUEUE_ACTIONS: (state, actions) => {
      if (actions.length) {
        if (!state.actions) {
          state.actions = [];
        }
        actions.forEach(function(action) {
          state.actions.push(action);
        });
      }
    },
    
    QUEUE_ACTIONS_INSERT: (state, actions) => {
      if (actions.length) {
        if (!state.actions) {
          state.actions = [];
        }
        state.actions = actions.concat(state.actions);
      }
    },

    POP_ACTION: (state, index) => {
      if (!index) {
        state.actions.shift();
        return;
      }
      index !== -1 ? state.actions.splice(index,1) : null;
    },
    
    PAUSE_ACTIONS: (state, isPaused ) => {
      state.isPaused = isPaused
    },
    
    POP_THREAD: (state, idThread) => {
      let index = state.threads ? state.threads.findIndex(e => e === idThread) : -1;
      (state.threads.length && (index !== -1)) ? state.threads.splice(index, 1) : null;
    },
    
    CLEAR_THREADS: (state) => {
      state.threads = []
    }
  },

  getters: {
    getActionsQueue: state => {
      return state.actions;
    }}
};
